import { createSlice } from '@reduxjs/toolkit';
import { ShareholderDistributionSubQuestionReducer } from '../../reducers/ShareholderDistributionSubQuestion';
import { IShareholderDistribution } from '../../../forms-v2/components/dynamic-fields/pi-shareholder-distribution/IShareholderDistribution';

const initialState: IShareholderDistribution = {
	list: [],
	isStart: true,
};

export const shareHolderDistributionSlice = createSlice({
	name: 'share-holder-distribution',
	initialState,
	reducers: ShareholderDistributionSubQuestionReducer,
});

export const { addShareholder, mergeList, resetListShareholder } =
	shareHolderDistributionSlice.actions;

export default shareHolderDistributionSlice.reducer;
